module.exports = __webpack_public_path__ + "img/qrcode.4a467f63.jpg";